module.exports = __webpack_public_path__ + "static/img/htb_order_pic.e5e704a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/home/htb_order_pic.png
// module id = z+/y
// module chunks = 31